<template>
    <div class="LibrariesComponent">
        <span v-if="!isMPN">
            <!-- <b-form-input size="sm" v-model="selectedFootprints" disabled></b-form-input>   -->
            <b-list-group v-for="item in selectedFootprints" :key="item.footprintId" size="sm">
                <b-list-group-item v-if="selectedFootprints.length > 0" class="flex-column align-items-start"
                    :variant="variant">
                    
                        
                            <p>{{ item.name }}</p>
                        
                    
                </b-list-group-item>

            </b-list-group>
            <br>
            <!-- <p>{{ lang.infotext_1 }}:</p><br> -->
            <LibraryTableComponent :reloadTable="reloadTable" :lang="lang.table_Libraries" :data="data"></LibraryTableComponent>
            
        </span>

        <!-- <b-tabs v-if="isMPN" v-model="tabIndex" card>

            <b-tab title="Libraries" :title-link-class="textColors" :title-item-class="textColors" active>

                
                <b-list-group v-for="item in selectedFootprints" :key="item.footprintId" size="sm">
                    <b-list-group-item v-if="selectedFootprints.length > 0" class="flex-column align-items-start"
                        :variant="variant">
                        <b-row>
                            <b-col cols="2">
                                <div :id="'place_svg_footprint__' + item.footprintId" class="image-footprint"></div>
                            </b-col>
                            <b-col cols="8">
                                <p>{{ item.name }}</p>
                            </b-col>

                        </b-row>
                    </b-list-group-item>

                </b-list-group>
                <br>
                <p>{{ lang.infotext_1 }}:</p><br>
                <LibraryTableComponent :reloadTable="reloadTable" :lang="lang.table_Libraries"></LibraryTableComponent>
                <br>
                <span v-if="!appConf.status.isLM">
                    <hr>
                    <p>{{ lang.infotext_2 }}:</p>
                    <b-form inline>

                        <b-form-input id="input-footprint-name" class="input-footprint-name" :state="inputStatus" size="sm"
                            v-model="footprintName" :placeholder="lang.placeholder_Create"
                            aria-describedby="input-footprint-feedback">
                        </b-form-input>

                        <b-form-file v-model="file" :state="Boolean(file)" :placeholder="lang.placeholder_file"
                            drop-placeholder="Drop file here..." class="import-file" accept=".svg" size="sm"></b-form-file>

                        <b-button class="btn create-button" size="sm" @click="createFootprint" :variant="variant">
                            {{ lang.button_Create }}</b-button>
                        <b-form-invalid-feedback id="input-footprint-feedback">
                            {{ lang.validinfo_1 }}
                        </b-form-invalid-feedback>



                    </b-form>
                </span>
            </b-tab>
            
        </b-tabs> -->

    </div>
</template>

<script>

import LibraryTableComponent from "@/components/shared/LibraryTableComponent"
import { mapGetters } from 'vuex'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
    name: 'LibrariesComponent',
    components: {
        LibraryTableComponent,
        
    },
    props: {
        lang: Object,
        selected: String,
        data: Object

    },
    data() {
        return {
            footprintName: "",
            inputStatus: null,
            reloadTable: false,
            file: null,
            isMPN: false,
            mpn: {},

            part: {},
            tabIndex: 0
        }
    },
    computed: {
        ...mapGetters([
            'appConf',

        ]),
        selectedFootprints() {
            if (this.$store.getters.selectedFootprints.length == 0) {
                return [];
            }
            return this.$store.getters.selectedFootprints;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        textColors() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return ['tabs-bg-dark', 'tabs-text-light']
            } else {
                return ['tabs-bg-light', 'tabs-text-dark']
            }

        },


    },
    created() {

        

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedFootprint");

        let vue = this;

        if (this.selected != "" && this.selected != undefined) {

            let obj = {
                propertyId: this.data.propertyId
            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + '_getGenericLibraries', obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {


                        let symbolId = "";
                        for (let j = 0, lej = result.data.length; j < lej; j++) {
                            if (result.data[j].name == vue.selected.trim()) {
                                symbolId = result.data[j].symbolId;
                                break;
                            }

                        }

                        const obj = {
                            name: vue.selected.trim(),
                            symbolId: symbolId
                        }
                        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_addSelectedFootprint", obj);



                    }

                })
        }





    },
    updated() {

        
    },
    watch: {
        selectedFootprints: function (newVal) {

            this.selectedFootprint = newVal[0];
        },

        reloadTable: function (newVal) {

            this.$nextTick(function () {

                if (newVal == true) {
                    this.reloadTable = false;
                }
            })


        },
        
    },
    methods: {
        
        
        deleteItem(item) {

            var newList = ""
            var temp = this.formProperty.split(",")
            for (var i = 0, le = temp.length; i < le; i++) {

                if (temp[i] != item) {
                    var t = temp[i]
                    newList += temp[i]
                    if (i < le - 1) {
                        newList += ","
                    }
                }


            }

            this.$store.commit('SETFORMPROPERTY', newList);

        },
        createFootprint() {

            if (this.footprintName != "") {
                let obj = {
                    name: this.footprintName,

                }
                let vue = this;
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_createFootprint", obj)
                    .then((result) => {

                        if (result.status == "OK") {

                            if (vue.file != null) {
                                const objFile = {
                                    type: LibraryTypes.FOOTPRINT,
                                    file: vue.file
                                }

                                
                            }

                            const obj = {
                                text: this.lang.alert_success_create_footprint,
                                time: 5,
                                type: "success"
                            }

                            this.$store.dispatch("displayFooterAlert", obj);

                            vue.footprintName = "";
                            vue.inputStatus = null;
                            vue.reloadTable = true;

                            let input = document.getElementById("input-footprint-name");

                            input.setAttribute("class", "input-footprint-name");

                            //todo reload table with footprints
                        } else {
                            const obj = {
                                text: this.lang.alert_error_create_footprint,
                                time: 10,
                                type: "danger"
                            }

                            this.$store.dispatch("displayFooterAlert", obj);
                        }
                    })


            } else {
                this.inputStatus = false;
            }



        },
        getSvg() {

            let vue = this;

            if (this.selectedFootprints[0] == undefined) {
                return
            }
            if (this.selectedFootprints[0].name == "") {
                return
            }
            for (let i = 0, lei = this.selectedFootprints.length; i < lei; i++) {
                const obj = {
                    type: LibraryTypes.FOOTPRINT,
                    name: this.selectedFootprints[0].name,
                    id: "place_svg_footprint__" + this.selectedFootprints[i].footprintId
                }
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSvg", obj)
                    .then((result) => {

                        if (result != null) {


                            let id = result.id;
                            vue.loadSVG(result, id);


                        }

                    })
            }


        },
        async loadSVG(blob, id) {

            let svgData = await new Response(blob).text();

            let place = document.getElementById(id);

            if (place != null) {
                place.innerHTML = "";

                var parser = new DOMParser();
                var doc = parser.parseFromString(svgData, "image/svg+xml");
                doc.documentElement.setAttribute("width", 100);
                doc.documentElement.setAttribute("height", 100);

                place.appendChild(doc.documentElement);

            }

        },
    }


}
</script>


<style lang="scss">
//@import "./../../scss/_modal.scss";


.list-group-item {
    padding: 0.25rem 0.25rem;


}

.create-button {
    margin-left: 10px;
}

.import-file {
    width: 400px !important;
    margin-left: 10px;


}

.input-footprint-name {
    width: 200px !important;
}

.image-footprint {
    background-color: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    margin: 5px;
    overflow: hidden;
    width: 100px;
    height: 100px;
    display: block;

}</style>



// WEBPACK FOOTER //
// src/components/shared/LibrariesComponent.vue